// noinspection DuplicatedCode

import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {changePassUser, userSelector} from "./userSlice";

import {Colors} from "../../assets/Colors";

function isRequired(value) {
    let status = false;
    if (value !== null) {
        if (typeof value === "number") {
            if (value !== -1) {
                status = true;
            }
        } else {
            if (value.trim().length > 0) {
                status = true;
            }
        }
    }
    return status;
}

function isSame(value1, value2) {
    return value1 === value2;
}

function useForm(
    initialState = {},
    validations = [],
    onSubmit = () => {
    }
) {
    const {isValid: initialIsValid, errors: initialErrors} = validate(
        validations,
        initialState
    );
    const [values, setValues] = useState(initialState);
    const [errors, setErrors] = useState(initialErrors);
    const [isValid, setValid] = useState(initialIsValid);
    const [touched, setTouched] = useState({});

    const changeHandler = (event) => {
        const newValues = {...values, [event.target.name]: event.target.value};
        const {isValid, errors} = validate(
            validations,
            newValues
        );

        setValues(newValues);
        setValid(isValid);
        setErrors(errors);
        setTouched({...touched, [event.target.name]: true});
    };

    const submitHandler = (event) => {
        event.preventDefault();
        onSubmit(values);
    };
    return {
        values,
        changeHandler,
        isValid,
        errors,
        touched,
        submitHandler,
    };
}

function validate(validations, values) {
    if (values.SistemGaji === "1") {
        validations = [...validations];
    }

    const errors = validations
        .map((validation) => validation(values))
        .filter((validation) => typeof validation === "object");
    return {
        isValid: errors.length === 0,
        errors: errors.reduce((errors, error) => ({...errors, ...error}), {}),
    };
}

const ChangePassPage = ({}) => {
    const dispatch = useDispatch();
    const user = useSelector(userSelector);
    let userData = JSON.parse(localStorage.getItem("user"));
    const initialState = {
        userName: "",
        password: "",
        newPassword: "",
    };

    const validations = [
        ({password}) =>
            isRequired(password) || {password: "Password lama wajib diisi"},

        ({newPassword}) =>
            isRequired(newPassword) || {
                newPassword: "Password baru wajib diisi",
            },

    ];

    const {
        values,
        isValid,
        errors,
        touched,
        changeHandler,
        submitHandler,
    } = useForm(initialState, validations);
    const [buttonTouched, setButtonTouched] = useState(false);

    useEffect(() => {
        if (user.isChangePassSuccess) {
            localStorage.removeItem("user");
            window.location.replace("/login");
        }
    });

    return (
        <div className="md:ml-64">
            <div className="m-4 p-4 border rounded">
                <div>
                    <label
                        className="capitalize block uppercase tracking-wide text-gray-800 text-xs font-bold mb-2"
                        htmlFor="input-one"
                    >
                        Old Password
                    </label>
                    <input
                        className="appearance-none block w-full text-gray-700 border hover:border-gray-800 rounded py-3 px-4 mb-3 leading-tight focus:outline-none bg-white"
                        type="text"
                        value={values.password}
                        onChange={changeHandler}
                        name="password"
                    />
                </div>
                <div>
                    <label
                        className="capitalize block uppercase tracking-wide text-gray-800 text-xs font-bold mb-2"
                        htmlFor="input-one"
                    >
                        New Password
                    </label>
                    <input
                        className="appearance-none block w-full text-gray-700 border hover:border-gray-800 rounded py-3 px-4 mb-3 leading-tight focus:outline-none bg-white"
                        type="text"
                        value={values.newPassword}
                        onChange={changeHandler}
                        name="newPassword"
                    />
                </div>
                <div className="flex justify-end">
                    <button
                        className="submitBtn"
                        style={{background: Colors.primary}}
                        onClick={() => {
                            if (!isValid) {
                                setButtonTouched(true);
                            }
                            if (isValid) {
                                let data = {
                                    userName: userData.Username
                                }
                                dispatch(changePassUser(Object.assign(values, data)));
                            }
                        }}
                    >
                        Submit
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ChangePassPage;
